import { z } from "zod";

/**
 * Disable Zod's JIT / `new Function` capability probe so strict CSP (`script-src 'self'`)
 * does not receive spurious violation reports. Must run before any schema is parsed.
 */
z.config({ jitless: true });
